import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { selectPatient } from '../../../redux/assessment';
import { AssessmentCard } from '../shared';
import { useLDFlags } from '../../providers/ld-flags';

const ConfirmEmail = () => {
  const { useMaterialComponentsAssessment } = useLDFlags();
  const { email } = useSelector(selectPatient);

  const content = (
    <Typography>
      Click the link we sent to{' '}
      <Typography fontWeight="medium" display="inline" component="span">
        {email}
      </Typography>{' '}
      to continue your assessment.
    </Typography>
  );

  return useMaterialComponentsAssessment ? (
    <AssessmentCard>{content}</AssessmentCard>
  ) : (
    content
  );
};

export default ConfirmEmail;
